import { forwardRef, useEffect } from 'react';
import { useUser } from '../../../hooks/useNavConfig';
import { getPortalId } from '../../../utils/getPortalId';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { Help } from './Help';
import { removeLocalStorage } from '../../../utils/localstorage';
import { jsx as _jsx } from "react/jsx-runtime";
const getGrowthSidePanelEligibilityLocalStorageCacheKey = (portalId = getPortalId(), userId) => {
  return userId ? `hs-growth-side-panel-eligibility::${portalId}::${userId}` : `hs-growth-side-panel-eligibility::${portalId}`;
};
const clearGrowthSidePanelEligibilityLocalStorageCache = (portalId = getPortalId(), userId) => {
  const localStorageKey = getGrowthSidePanelEligibilityLocalStorageCacheKey(portalId, userId);
  removeLocalStorage(localStorageKey);
};
export const HelpButtonContainer = memoWithDisplayName('HelpButtonContainer', /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id: userId
  } = useUser();
  useEffect(() => {
    clearGrowthSidePanelEligibilityLocalStorageCache(getPortalId(), userId);
  }, [userId]);
  return /*#__PURE__*/_jsx(Help, Object.assign({}, props, {
    ref: ref
  }));
}));
export default HelpButtonContainer;